module.exports = __webpack_public_path__ + "img/bg-s.b6988c00.svg";